import React from 'react';

import { Action, Actions, HelpIcon } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { Screen, withScreen, createScreenRoute } from '@gogame/screens';

import BulkUploader from './components/BulkUpload';
import DictionarySidePage from './components/DictionarySidePage';
import Partners from './components/Partners';
import { bulkUploadSearchParams, bulkUploadLink } from './navigation';
import screenReducer from './screenReducer';

const id = 39;
const permission = 62;

const BulkUpload = withScreen({
  title: 'Bulk Upload',
  name: 'bulk-upload',
  searchParams: bulkUploadSearchParams,
  reducer: screenReducer,
})(() => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleOpenDictionary = () => {
    openChildComponent(DictionarySidePage);
  };

  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <Screen.Toolbar.Actions>
          <Actions>
            <Action
              icon={<HelpIcon />}
              onClick={handleOpenDictionary}
              label={'Help'}
            />
          </Actions>
        </Screen.Toolbar.Actions>
        <Screen.Toolbar.FiltersApply>
          <Partners />
        </Screen.Toolbar.FiltersApply>
        <BulkUploader />
        {childComponent}
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Bulk Upload',
  link: bulkUploadLink,
  screen: <BulkUpload />,
  id: id,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/360011049579-Facebook-Bulk-Upload',
});
